/**
 * Copies an AI log-query draft into Log Explorer filter state.
 * Index and application stay source filters. The search body is still { query }.
 * This does not run the search.
 */
export function draftSearchFilters(current, draft, sources) {
  const filters = current || {};
  const index = String(draft?.index || "").trim();
  const application = String(draft?.application || "").trim();
  const query = String(draft?.query || "").trim();
  if (!query) {
    return { error: "The draft does not include a query.", filters };
  }
  if (index) {
    const matched = (sources || []).filter((source) => source.indexName === index);
    if (matched.length === 0) {
      return {
        error: `No log source is configured for index "${index}"${application ? ` / application "${application}"` : ""}. The current source filters were left unchanged.`,
        filters
      };
    }
    if (application && !matched.some((source) => sourceHasApplication(source, application))) {
      return {
        error: `No log source is configured for index "${index}" / application "${application}". The current source filters were left unchanged.`,
        filters
      };
    }
  } else if (application) {
    return {
      error: `The application "${application}" cannot be applied without an index. The current source filters were left unchanged.`,
      filters
    };
  }
  const selectedIndex = index || filters.selectedIndex || "";
  const selectedApplication = application || filters.selectedApplication || "";
  return {
    error: "",
    filters: {
      ...filters,
      logql: query,
      keyword: "",
      ...(index ? { selectedIndex: index } : {}),
      ...(application ? { selectedApplication: application } : {})
    },
    request: {
      body: { query },
      selectedIndex,
      selectedApplication
    }
  };
}

function sourceHasApplication(source, applicationName) {
  const needle = applicationName.trim().toLowerCase();
  const names = [
    source?.applicationName,
    ...(Array.isArray(source?.applications) ? source.applications : [])
  ];
  return names.some((app) => String(app || "").trim().toLowerCase() === needle);
}
